var _path, _ellipse, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _circle, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoprojectfound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 89,
    viewBox: "0 0 156 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.003 11.4253C152.591 11.4253 155.5 14.3497 155.5 17.957C155.5 21.5644 152.591 24.4888 149.003 24.4888H111.877C115.465 24.4888 118.374 27.4131 118.374 31.0205C118.374 34.6279 115.465 37.5523 111.877 37.5523H132.296C135.885 37.5523 138.793 40.4766 138.793 44.084C138.793 47.6914 135.885 50.6158 132.296 50.6158H122.854C118.329 50.6158 114.662 53.5401 114.662 57.1475C114.662 59.5524 116.518 61.7297 120.231 63.6792C123.819 63.6792 126.728 66.6036 126.728 70.211C126.728 73.8184 123.819 76.7427 120.231 76.7427H43.1946C39.6064 76.7427 36.6976 73.8184 36.6976 70.211C36.6976 66.6036 39.6064 63.6792 43.1946 63.6792H6.99701C3.40881 63.6792 0.5 60.7549 0.5 57.1475C0.5 53.5401 3.40881 50.6158 6.99701 50.6158H44.1228C47.711 50.6158 50.6198 47.6914 50.6198 44.084C50.6198 40.4766 47.711 37.5523 44.1228 37.5523H20.9192C17.331 37.5523 14.4222 34.6279 14.4222 31.0205C14.4222 27.4131 17.331 24.4888 20.9192 24.4888H58.0449C54.4567 24.4888 51.5479 21.5644 51.5479 17.957C51.5479 14.3497 54.4567 11.4253 58.0449 11.4253H149.003ZM149.003 37.5523C152.591 37.5523 155.5 40.4766 155.5 44.084C155.5 47.6914 152.591 50.6158 149.003 50.6158C145.415 50.6158 142.506 47.6914 142.506 44.084C142.506 40.4766 145.415 37.5523 149.003 37.5523Z",
    fill: "#D6DCE8"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 70.8601,
    cy: 37.002,
    rx: 25.8474,
    ry: 25.9356,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3931 40.463C61.865 40.463 63.1105 39.2133 63.1105 37.7364C63.1105 36.2595 61.865 35.0098 60.3931 35.0098C58.9212 35.0098 57.6758 36.2595 57.6758 37.7364C57.6758 39.2133 58.9212 40.463 60.3931 40.463Z",
    fill: "#989FB0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2266 40.463C82.6985 40.463 83.944 39.2133 83.944 37.7364C83.944 36.2595 82.6985 35.0098 81.2266 35.0098C79.7547 35.0098 78.5093 36.2595 78.5093 37.7364C78.5093 39.3269 79.7547 40.463 81.2266 40.463Z",
    fill: "#989FB0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2882 28.7135L54.3105 31.9521L55.1175 33.4517L61.0952 30.213L60.2882 28.7135Z",
    fill: "#989FB0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8563 28.6703L80.0496 30.1699L86.0277 33.4077L86.8344 31.9081L80.8563 28.6703Z",
    fill: "#989FB0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8106 46.8238C72.5615 46.8238 73.9809 45.7557 73.9809 44.438C73.9809 43.1204 72.5615 42.0522 70.8106 42.0522C69.0598 42.0522 67.6404 43.1204 67.6404 44.438C67.6404 45.7557 69.0598 46.8238 70.8106 46.8238Z",
    fill: "#989FB0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M102.403 71.7601L87.2944 56.5835L90.758 53.1016L105.854 68.2901L102.403 71.7601Z",
    fill: "#858B9B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M109.926 79.385L98.3413 67.7384C97.3739 66.7659 97.3739 65.181 98.3413 64.2084C99.3087 63.2359 100.885 63.2359 101.853 64.2084L113.438 75.855C114.405 76.8275 114.405 78.4124 113.438 79.385C112.47 80.3575 110.894 80.3575 109.926 79.385Z",
    fill: "#858B9B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M109.1 80.1312L94.1951 65.1467C93.8487 64.7985 93.8487 64.2342 94.1951 63.874L98.005 60.0439C98.3513 59.6957 98.9127 59.6957 99.271 60.0439L114.176 75.0283C114.522 75.3765 114.522 75.9408 114.176 76.301L110.366 80.1312C110.008 80.4794 109.447 80.4794 109.1 80.1312Z",
    fill: "url(#paint0_linear_31762_229667)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1929 7.68164C54.3801 7.68164 41.5649 20.5649 41.5649 36.4618C41.5649 52.3468 54.3801 65.242 70.181 65.242C85.9939 65.242 98.809 52.3588 98.809 36.4618C98.809 20.5649 85.9939 7.68164 70.1929 7.68164ZM70.1929 59.911C57.4972 59.911 47.2141 49.4051 47.2141 36.4498C47.2141 23.4945 57.4972 13.0006 70.1929 13.0006C82.8886 13.0006 93.1718 23.5065 93.1718 36.4618C93.1718 49.4171 82.8767 59.911 70.1929 59.911Z",
    fill: "url(#paint1_linear_31762_229667)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.9352,
    cy: 71.9899,
    r: 4.65882,
    fill: "#D6DCE8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_31762_229667",
    x1: 93.9259,
    y1: 70.0898,
    x2: 114.44,
    y2: 70.0898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_31762_229667",
    x1: 41.5387,
    y1: 36.4681,
    x2: 98.8194,
    y2: 36.4681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoprojectfound);
export default __webpack_public_path__ + "static/media/noprojectfound.dcc57968b6e1263ddf628525a817255b.svg";
export { ForwardRef as ReactComponent };